import {batch, signal} from "@preact/signals-react";

export const UserActivitiesIsEmpty = signal(false)
export const isLoadingMetric = signal(false)
export const isLoadingCards = signal(false)
export const isLoadingTops = signal([])
export const isLoadingKpi = signal(false)
export const isLoadingEvo = signal(false)
export const isLoadingTable = signal(false)
export const userActivitiesTabID = signal(null)
export const appliedCustomerIDs = signal([])

export const resetUserActivityTabs = () => batch(() => {
    UserActivitiesIsEmpty.value = null;
    userActivitiesTabID.value = null;
    isLoadingTops.value = [];
})

export const addLoadingInUsersActivitiesLoadingTops = key => {
	if (isLoadingTops.value.length === 0)
		userActivitiesTabID.value = null
	isLoadingTops.value = [
		...isLoadingTops.value, key
	]
}
export const removeLoadingInUsersActivitiesLoadingTops = key => {
	if (isLoadingTops.value.length === 3)
		userActivitiesTabID.value = key
	isLoadingTops.value = isLoadingTops.value.filter(oldKey => oldKey !== key)
}